/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createRandom } from '../../factoriesAny.js';
export var randomDependencies = {
  typedDependencies: typedDependencies,
  createRandom: createRandom
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRandom.generated.js
// module id = 1488
// module chunks = 0